import Vue from 'vue'
import * as api from '../api/mailV2Api'

const state = Vue.observable({
  templates: [],
  types: [],
  settings: null,
  layouts: [],
  currentTemplate: null,
  previewHtml: '',
  loading: false,
})

export function useMailV2Store() {
  return {
    // State (reactive)
    get templates() { return state.templates },
    get types() { return state.types },
    get settings() { return state.settings },
    get layouts() { return state.layouts },
    get currentTemplate() { return state.currentTemplate },
    get previewHtml() { return state.previewHtml },
    get loading() { return state.loading },

    // --- Organisation - Templates ---

    async listTemplates(holderType, holderId, params) {
      if (params === undefined) params = {}
      state.loading = true
      try {
        var result = await api.listTemplates(holderType, holderId, params)
        state.templates = Array.isArray(result) ? result : []
        return state.templates
      } finally {
        state.loading = false
      }
    },

    async customizeTemplate(holderType, holderId, mailTypeId) {
      state.loading = true
      try {
        var result = await api.customizeTemplate(holderType, holderId, mailTypeId)
        state.currentTemplate = result
        return result
      } finally {
        state.loading = false
      }
    },

    async getTemplate(holderType, holderId, templateId) {
      state.loading = true
      try {
        var result = await api.getTemplate(holderType, holderId, templateId)
        state.currentTemplate = result
        return result
      } finally {
        state.loading = false
      }
    },

    async updateTemplate(holderType, holderId, templateId, data) {
      state.loading = true
      try {
        var result = await api.updateTemplate(holderType, holderId, templateId, data)
        state.currentTemplate = result
        return result
      } finally {
        state.loading = false
      }
    },

    async deleteTemplate(holderType, holderId, templateId) {
      return api.deleteTemplate(holderType, holderId, templateId)
    },

    async previewTemplate(holderType, holderId, data) {
      state.loading = true
      try {
        var result = await api.previewTemplate(holderType, holderId, data)
        state.previewHtml = (result && result.html) ? result.html : (result || '')
        return result
      } finally {
        state.loading = false
      }
    },

    async previewRaw(holderType, holderId, data) {
      var result = await api.previewRaw(holderType, holderId, data)
      return (result && result.html) ? result.html : (result || '')
    },

    async sendTest(holderType, holderId, data) {
      return api.sendTest(holderType, holderId, data)
    },

    // --- Organisation - Types ---

    async listTypes(holderType, holderId) {
      var result = await api.listTypes(holderType, holderId)
      state.types = Array.isArray(result) ? result : []
      return state.types
    },

    // --- Organisation - Settings ---

    async getSettings(holderType, holderId) {
      state.loading = true
      try {
        var result = await api.getSettings(holderType, holderId)
        state.settings = result
        return result
      } finally {
        state.loading = false
      }
    },

    async updateSettings(holderType, holderId, data) {
      state.loading = true
      try {
        var result = await api.updateSettings(holderType, holderId, data)
        state.settings = result
        return result
      } finally {
        state.loading = false
      }
    },

    // --- Admin - Layouts ---

    async listLayouts(holderType, holderId) {
      var result = await api.listLayouts(holderType, holderId)
      state.layouts = Array.isArray(result) ? result : []
      return state.layouts
    },

    async getLayout(holderType, holderId, layoutId) {
      return api.getLayout(holderType, holderId, layoutId)
    },

    async updateLayout(holderType, holderId, layoutId, data) {
      return api.updateLayout(holderType, holderId, layoutId, data)
    },

    async previewLayout(holderType, holderId, layoutId, data) {
      if (data === undefined) data = {}
      return api.previewLayout(holderType, holderId, layoutId, data)
    },

    // --- Admin - Types ---

    async adminListTypes(holderType, holderId, params) {
      if (params === undefined) params = {}
      var result = await api.adminListTypes(holderType, holderId, params)
      return Array.isArray(result) ? result : []
    },

    async adminGetType(holderType, holderId, typeId) {
      return api.adminGetType(holderType, holderId, typeId)
    },

    async adminUpdateType(holderType, holderId, typeId, data) {
      return api.adminUpdateType(holderType, holderId, typeId, data)
    },

    async adminUpdateDefault(holderType, holderId, typeId, data) {
      return api.adminUpdateDefault(holderType, holderId, typeId, data)
    },

    async adminSendTest(holderType, holderId, typeId, data) {
      return api.adminSendTest(holderType, holderId, typeId, data)
    },

    // --- Helpers ---

    resetCurrent() {
      state.currentTemplate = null
      state.previewHtml = ''
    },
  }
}
